import type {
    ProfileExpertisesResource,
    ProfileIndustryExpertiseResource,
    ProfileSkillResource,
    ProfileSkillTypeResource,
} from '~/types/api-raw-types';

export enum ExpertiseLevel {
    NONE,
    BEGINNER,
    INTERMEDIATE,
    ADVANCED,
}

export enum SelectedSkillType {
    GLOBAL,
    FUNCTIONAL,
}

export class ProfileIndustryExpertise {
    id: string;
    label: string;
    seoUrl?: string;

    constructor(params: ProfileIndustryExpertiseResource) {
        this.id = params.id;
        this.label = params.label;
        this.seoUrl = params.seoUrl;
    }

    toJSON() {
        return {
            ...this,
        };
    }
}

export type ProfileSelectedSkillSetItem = {
    type: SelectedSkillType;
    id: string;
    label: string;
    seoUrl?: string;
    translatedLabel?: string;
};

export class ProfileExpertises {
    industryExpertises: ProfileIndustryExpertise[];
    selectedSkills: ProfileSelectedSkillSetItem[];
    topSkills: ProfileSelectedSkillSetItem[];

    constructor(params: ProfileExpertisesResource) {
        this.industryExpertises = params.industryExpertises.map((industryExpertise) => new ProfileIndustryExpertise(industryExpertise));
        this.selectedSkills = params.selectedSkillsOrder.map((selectedSkill) => toProfileSelectedSkillSetItem(selectedSkill));
        this.topSkills = params.topSkills.map((topSkill) => toProfileSelectedSkillSetItem(topSkill));
    }

    toJSON() {
        return {
            ...this,
        };
    }
}

function toSelectedSkillType(skillTypeResource: ProfileSkillTypeResource): SelectedSkillType {
    switch (skillTypeResource) {
        case 'FUNCTIONAL':
            return SelectedSkillType.FUNCTIONAL;
        case 'GLOBAL':
            return SelectedSkillType.GLOBAL;
    }
}

function toProfileSelectedSkillSetItem(skillResource: ProfileSkillResource): ProfileSelectedSkillSetItem {
    return {
        type: toSelectedSkillType(skillResource.type),
        id: skillResource.id,
        label: skillResource.label,
        seoUrl: skillResource.seoUrl,
        translatedLabel: skillResource.translatedLabel,
    };
}
